var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"body",staticClass:"app-body",attrs:{"id":"app-body"}},[_c('sidebar-left'),_vm._v(" "),_c('transition',{attrs:{"name":"view","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('sidebar-right')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f1ae74","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Body.vue
// module id = 35
// module chunks = 10